import { ExpenseType } from 'api/model';
import { Option } from 'components/inputs/MultiSelect';
import { expectableExpenses } from 'constants/AppConstants';
import useTranslations from 'contexts/basicData/useTranslations';
import { useMemo } from 'react';

const useExpenseTypeOptions = () => {
  const { expenseTypes } = useTranslations();

  const options: Option<string>[] = useMemo(
    () =>
      expectableExpenses
        .filter((s) => typeof s === 'number')
        .sort((a, b) => {
          const aLabel = expenseTypes[a as ExpenseType];
          const bLabel = expenseTypes[b as ExpenseType];
          if (aLabel && bLabel) {
            return aLabel.localeCompare(bLabel);
          }
          return 0; // handle undefined and null cases, or adapt as needed
        })
        .map((v) => ({
          key: v.toString(),
          value: v.toString(),
          label: expenseTypes[v as ExpenseType] ?? '',
        })),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  return options;
};

export default useExpenseTypeOptions;
